import React from 'react';
import Button, {StyleType} from 'patient-ping-remedy/packages/button';
import {router} from '@/router';
import ErrorPage from '@/components/pages/error_pages/ErrorPage';
import {ErrorCenter} from '@/components/pages/error_pages/ErrorPage.styles';

export default function Unauthorized() {
  const rawMessage = (sessionStorage.getItem('user_deleted') || '{}');

  const response = JSON.parse(rawMessage);
  sessionStorage.removeItem('user_deleted');

  return (
    <ErrorPage title={response.title ?? "Error! Your account is currently disabled."}>
      <span>Please contact your account manager.</span>
      <ErrorCenter>
        <Button
          onClick={() => {
            router.navigate('/');
          }}
          styleType={StyleType.SECONDARY}
        >
              Return to Login
        </Button>
      </ErrorCenter>
    </ErrorPage>
  );
}
